import { error, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const EstimateTransferOptionsQuery = gql`
  query GetEstimateTransferOptions($input: TransferOptionsInput) {
    transferOptions(input: $input) {
      ... on TransferOptions {
        type
        transferEstimate
        maxTransfer {
          ...money
        }
      }
      ... on TransferNotPossibleError {
        ...error
      }
    }
  }
  ${error}
  ${money}
`;

export default EstimateTransferOptionsQuery;
